/**
 * Display precision policy for OD insights (org-design-definitions.md):
 * counts (headcount, layers, managers, the "1:" side of ratios) stay
 * integers; measured continuous values (averages, ratio N sides,
 * percentages) always show exactly 2 decimals so the same number formats
 * identically on every surface (tiles, widgets, mini-map, captions).
 *
 * Lives in its own module: util/teamMetrics and util/insightsHierarchyView
 * both need it and already import in opposite directions.
 */

export const formatDecimal2 = (value: number): string => value.toFixed(2);

export const formatPercent2 = (value: number): string => `${value.toFixed(2)}%`;

/** Manager:IC — integer "1" side, 2dp continuous side. */
export const formatRatio2 = (icsPerManager: number): string =>
  `1:${icsPerManager.toFixed(2)}`;

/** Signed 2dp for deltas of continuous metrics ("+0.49", "-1.60", "0.00"). */
export const formatSignedDecimal2 = (delta: number): string =>
  delta > 0 ? `+${delta.toFixed(2)}` : delta.toFixed(2);
